import "react-app-polyfill/stable";
import "core-js";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store";
import ReactGA from "react-ga4";
import mixpanel from "mixpanel-browser";

// Initializing Google Analytics
if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
  ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);
}

// Initilaizing Mix Panel
if (process.env.REACT_APP_MIX_PANEL_TOKEN) {
  mixpanel.init(process.env.REACT_APP_MIX_PANEL_TOKEN, {
    track_pageview: "full-url",
    persistence: "localStorage",
    // Session Replay Configurations
    record_idle_timeout_ms: 900000, // 15 minutes
    record_max_ms: 900000, // 15 minutes
    record_block_class: null,
    record_block_selector: null,
    record_mask_text_class: null,
    record_mask_text_selector: null,
  });
}

createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <App />
  </Provider>,
);

reportWebVitals();
